import { render, staticRenderFns } from "./container_factory_purchase.vue?vue&type=template&id=35a80894&scoped=true&"
import script from "./container_factory_purchase.vue?vue&type=script&lang=js&"
export * from "./container_factory_purchase.vue?vue&type=script&lang=js&"
import style0 from "./container_factory_purchase.vue?vue&type=style&index=0&id=35a80894&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a80894",
  null
  
)

export default component.exports